import { useQuery } from 'hooks/useQuery';
import { listStreamers } from 'lib/api/streamers';
import { HookQueryOptions, queryKey } from './shared';

interface StreamerRequest {
  limit?: number;
  socials?: string;
  sortBy?: string;
}

export const useStreamersQuery = (
  payload: StreamerRequest = {},
  options?: HookQueryOptions
) =>
  useQuery(queryKey('streamers.list', payload), () => listStreamers(payload), {
    skip: options?.skip,
  });
